import { render, staticRenderFns } from "./ExtendedCountdown.vue?vue&type=template&id=a2d041bc&scoped=true&"
import script from "./ExtendedCountdown.vue?vue&type=script&lang=ts&"
export * from "./ExtendedCountdown.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendedCountdown.vue?vue&type=style&index=0&id=a2d041bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d041bc",
  null
  
)

export default component.exports